import {ValueObject} from '@s-ui/domain'

export class UserConsentUserValueObject extends ValueObject {
  #key
  #status

  /**
   * @param {String} key
   * @param {Boolean} status
   * */
  static create({key, status}) {
    return new UserConsentUserValueObject({key, status})
  }

  constructor({key, status}) {
    super()

    this.#key = key
    this.#status = status
  }

  get key() {
    return this.#key
  }

  get status() {
    return this.#status
  }

  set status(status) {
    this.#status = status
  }

  toJSON() {
    return {key: this.#key, status: this.#status}
  }
}
